import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use( VueGoogleMaps, {
  load: {
    key: 'AIzaSyDP5pWf2lZ8fH_MEQ-tHrDPGTLBietm75c',
    libraries: 'places' // necessary for places input
  }
});
